import { render } from "./MinhaContribuicao.vue?vue&type=template&id=47850044"
import script from "./MinhaContribuicao.vue?vue&type=script&lang=js"
export * from "./MinhaContribuicao.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__